import { Promo } from './widgets';

export const TravelPage = () => {
  return <Promo />;
};
